import { type ReactElement, type ReactNode, useEffect } from "react";

import { refresh } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";

export function AuthBootstrap({ children }: { children: ReactNode }): ReactElement {
  const bootstrapped = useAuthStore((s) => s.bootstrapped);
  const setSession = useAuthStore((s) => s.setSession);
  const markBootstrapped = useAuthStore((s) => s.markBootstrapped);

  useEffect(() => {
    if (bootstrapped) return;
    void (async () => {
      try {
        const res = await refresh();
        setSession(res.user, res.token.access_token);
      } catch {
        markBootstrapped();
      }
    })();
  }, [bootstrapped, setSession, markBootstrapped]);

  if (!bootstrapped) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-n-50">
        <p className="text-sm text-n-500">Loading…</p>
      </div>
    );
  }
  return <>{children}</>;
}
